import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiTranslateModule } from '@fcom/ui-translate';
import { UiComponentsModule } from '@fcom/ui-components';
import { CmsModule } from '@fcom/cms/components';
import { ComponentsModule, DirectiveModule, PipesModule } from '@fcom/common';
import {
  CommonBookingComponentsModule,
  BookingOrderService,
  CommonBookingAncillariesModule,
} from '@fcom/common-booking';
import { QualtricsModule } from '@fcom/common/qualtrics/qualtrics.module';
import {
  CommonBookingPurchaseSuccessModule,
  PurchaseSuccessService,
} from '@fcom/common-booking/modules/purchase-success';
import { BookingCommonModule } from '@fcom/booking/modules/common/booking-common.module';

import { ManageBookingCommonModule } from '../common/booking-common.module';
import { ManageBookingPurchaseSuccessRouteComponent } from './routes/purchase-success-route.component';
import { ManageBookingPurchaseSuccessGuard } from './services/purchase-success.guard';
import { ManageBookingPurchaseSuccessComponent } from './components/purchase-success.component';
import { CarTrawlerWidgetModule } from '../../modules/common/components/cartrawler-widget/cartrawler-widget.module';

@NgModule({
  imports: [
    BookingCommonModule,
    CommonModule,
    ComponentsModule,
    ManageBookingCommonModule,
    CommonBookingComponentsModule,
    CommonBookingAncillariesModule,
    CommonBookingPurchaseSuccessModule,
    CmsModule,
    PipesModule,
    QualtricsModule,
    DirectiveModule,
    UiTranslateModule,
    UiComponentsModule,
    CarTrawlerWidgetModule,
  ],
  declarations: [ManageBookingPurchaseSuccessRouteComponent, ManageBookingPurchaseSuccessComponent],
  exports: [ManageBookingPurchaseSuccessRouteComponent],
  providers: [ManageBookingPurchaseSuccessGuard, PurchaseSuccessService, BookingOrderService],
})
export class ManageBookingPurchaseSuccessModule {}
